export default __webpack_public_path__ + "static/B0123-9e8d8caf79ba80e583300bca58c7b0ea.png";